// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-button {
  cursor: pointer;
  display: flex;
  height: 40px;
}

.reset-button:hover {
  filter: brightness(0.9);
}

.category-filters {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.category-filters select {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  width: 250px;
}

.category-filters button {
  background: none;
  border: none;
  display: flex;
}

.crud-section {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px;
  margin-top: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.crud-section h2 {
  font-size: 1.5em;
  margin-bottom: 15px;
  color: #34495e;
}

.entryCRUD {
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  margin: 0 4px;
  color: #fff;
}

#crudDelete {
  background-color: #cc2b52;
}

#crudDelete:hover {
  filter: brightness(1.1);
  transition: 0.1s ease-in;
}

#crudUpdate {
  background-color: #f3c623;
}

#crudUpdate:hover {
  filter: brightness(1.1);
  transition: 0.1s ease-in;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.btn-back {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
  padding: 10px 20px;
  cursor: pointer;
}

.btn-back:hover {
  background-color: #ddd;
}

.btn-save {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
}

.btn-save:hover {
  background-color: #0056b3;
}

/* Overlay untuk latar belakang */
.popupOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* Transparansi kehitaman */
  z-index: 999;
}

/* Popup */
.popupMessage {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: #fff;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
  text-align: center;
  animation: fadeIn 0.3s ease-in-out;
}

/* Animasi fade-in */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Tambahkan warna untuk jenis pesan */
.popupMessage.success {
  border-color: green;
}

.popupMessage.error {
  border-color: red;
}

.popup-content {
  text-align: center;
}

.popup-content p {
  /* margin: 0 0 20px; */
  font-size: 16px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate(-50%, -60%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

.confirmation-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.confirmation-popup .popup-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.confirmation-popup h2 {
  margin: 0 0 10px;
  font-size: 18px;
}

.confirmation-popup p {
  margin: 0 0 20px;
  font-size: 14px;
}

.confirmation-popup .popup-actions {
  display: flex;
  justify-content: space-between;
}

.confirmation-popup .btn-confirm {
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.confirmation-popup .btn-cancel {
  background: #dc3545;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.confirmation-popup .btn-confirm:hover,
.confirmation-popup .btn-cancel:hover {
  opacity: 0.9;
}

.category-filters .btn-add-main {
  background-color: #34495e;
  padding: 0.7rem 1rem 0.7rem 1rem;
  color: #fff;
  border-radius: 5px;
}

.category-filters .btn-add-main:hover {
  filter: brightness(1.1);
}

#addMainCategoryForm .btn-save-main-cat {
  background-color: #34495e;
  padding: 0.2rem 2rem;
  border: none;
  color: #fff;
}

#addMainCategoryForm .btn-save-main-cat:hover {
  filter: brightness(0.9);
}

#addCategoryForm .btn-save-main-cat {
  background-color: #34495e;
  padding: 0.2rem 2rem;
  border: none;
  color: #fff;
}

#addCategoryForm .btn-save-main-cat:hover {
  filter: brightness(0.9);
}

#addSubCategory {
  background-color: #34495e;
  padding: 0.5rem 2rem;
  border: none;
  color: #fff;
}

#addSubCategory:hover {
  filter: brightness(0.9);
}

#addSubSubCategory {
  background-color: #34495e;
  padding: 0.5rem 2rem;
  border: none;
  color: #fff;
}

#addSubSubCategory:hover {
  filter: brightness(0.9);
}
`, "",{"version":3,"sources":["webpack://./src/styles/budget.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC,EAAE,2BAA2B;EACjE,YAAY;AACd;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".reset-button {\r\n  cursor: pointer;\r\n  display: flex;\r\n  height: 40px;\r\n}\r\n\r\n.reset-button:hover {\r\n  filter: brightness(0.9);\r\n}\r\n\r\n.category-filters {\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.category-filters select {\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  width: 250px;\r\n}\r\n\r\n.category-filters button {\r\n  background: none;\r\n  border: none;\r\n  display: flex;\r\n}\r\n\r\n.crud-section {\r\n  background-color: #ffffff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  padding: 20px;\r\n  margin-top: 20px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.crud-section h2 {\r\n  font-size: 1.5em;\r\n  margin-bottom: 15px;\r\n  color: #34495e;\r\n}\r\n\r\n.entryCRUD {\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  border: none;\r\n  border-radius: 5px;\r\n  margin: 0 4px;\r\n  color: #fff;\r\n}\r\n\r\n#crudDelete {\r\n  background-color: #cc2b52;\r\n}\r\n\r\n#crudDelete:hover {\r\n  filter: brightness(1.1);\r\n  transition: 0.1s ease-in;\r\n}\r\n\r\n#crudUpdate {\r\n  background-color: #f3c623;\r\n}\r\n\r\n#crudUpdate:hover {\r\n  filter: brightness(1.1);\r\n  transition: 0.1s ease-in;\r\n}\r\n\r\n.form-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.btn-back {\r\n  background-color: #f0f0f0;\r\n  color: #333;\r\n  border: 1px solid #ccc;\r\n  padding: 10px 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-back:hover {\r\n  background-color: #ddd;\r\n}\r\n\r\n.btn-save {\r\n  background-color: #007bff;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-save:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n/* Overlay untuk latar belakang */\r\n.popupOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.5); /* Transparansi kehitaman */\r\n  z-index: 999;\r\n}\r\n\r\n/* Popup */\r\n.popupMessage {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 1000;\r\n  background-color: #fff;\r\n  padding: 20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\r\n  max-width: 400px;\r\n  width: 90%;\r\n  text-align: center;\r\n  animation: fadeIn 0.3s ease-in-out;\r\n}\r\n\r\n/* Animasi fade-in */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Tambahkan warna untuk jenis pesan */\r\n.popupMessage.success {\r\n  border-color: green;\r\n}\r\n\r\n.popupMessage.error {\r\n  border-color: red;\r\n}\r\n\r\n.popup-content {\r\n  text-align: center;\r\n}\r\n\r\n.popup-content p {\r\n  /* margin: 0 0 20px; */\r\n  font-size: 16px;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translate(-50%, -60%);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n}\r\n\r\n.confirmation-popup {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.confirmation-popup .popup-content {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.confirmation-popup h2 {\r\n  margin: 0 0 10px;\r\n  font-size: 18px;\r\n}\r\n\r\n.confirmation-popup p {\r\n  margin: 0 0 20px;\r\n  font-size: 14px;\r\n}\r\n\r\n.confirmation-popup .popup-actions {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.confirmation-popup .btn-confirm {\r\n  background: #28a745;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.confirmation-popup .btn-cancel {\r\n  background: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.confirmation-popup .btn-confirm:hover,\r\n.confirmation-popup .btn-cancel:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n.category-filters .btn-add-main {\r\n  background-color: #34495e;\r\n  padding: 0.7rem 1rem 0.7rem 1rem;\r\n  color: #fff;\r\n  border-radius: 5px;\r\n}\r\n\r\n.category-filters .btn-add-main:hover {\r\n  filter: brightness(1.1);\r\n}\r\n\r\n#addMainCategoryForm .btn-save-main-cat {\r\n  background-color: #34495e;\r\n  padding: 0.2rem 2rem;\r\n  border: none;\r\n  color: #fff;\r\n}\r\n\r\n#addMainCategoryForm .btn-save-main-cat:hover {\r\n  filter: brightness(0.9);\r\n}\r\n\r\n#addCategoryForm .btn-save-main-cat {\r\n  background-color: #34495e;\r\n  padding: 0.2rem 2rem;\r\n  border: none;\r\n  color: #fff;\r\n}\r\n\r\n#addCategoryForm .btn-save-main-cat:hover {\r\n  filter: brightness(0.9);\r\n}\r\n\r\n#addSubCategory {\r\n  background-color: #34495e;\r\n  padding: 0.5rem 2rem;\r\n  border: none;\r\n  color: #fff;\r\n}\r\n\r\n#addSubCategory:hover {\r\n  filter: brightness(0.9);\r\n}\r\n\r\n#addSubSubCategory {\r\n  background-color: #34495e;\r\n  padding: 0.5rem 2rem;\r\n  border: none;\r\n  color: #fff;\r\n}\r\n\r\n#addSubSubCategory:hover {\r\n  filter: brightness(0.9);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
